import { render, staticRenderFns } from "./DefaultList.vue?vue&type=template&id=673a9512&scoped=true&"
import script from "./DefaultList.vue?vue&type=script&lang=js&"
export * from "./DefaultList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultList.vue?vue&type=style&index=0&id=673a9512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a9512",
  null
  
)

export default component.exports